import { render, staticRenderFns } from "./LoginMenuButton.vue?vue&type=template&id=0fbbaf9a&scoped=true"
import script from "./LoginMenuButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginMenuButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginMenuButton.vue?vue&type=style&index=0&id=0fbbaf9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbaf9a",
  null
  
)

export default component.exports